import VeersaLoaderGif from "../../common/icons/Veersa-loader.gif";

export default function CircularLoader(){
  return(
    <div style={{display: 'flex', justifyContent: 'center'}}>
        <div style={{
          backgroundColor: 'white',
          padding: '12px',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <img 
            src={VeersaLoaderGif} 
            alt="Loading..." 
            style={{ width: '52px', height: '52px', marginBottom: '8px' }}
          />
          <span style={{ color: '#1976d2', fontSize: '12px', fontWeight: '500' }}>Loading...</span>
        </div>
    </div>
  )
}